export const variables ={
    API_URL:"https://trainbookingapi.azurewebsites.net/api/"
}